exports.list = {
    path: '/ulm_inside_outside',
    name: 'ulm_inside_outside_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/ulm_inside_outside/List.vue"),
}
exports.show = {
    path: '/ulm_inside_outside/show/:id',
    name: 'ulm_inside_outside_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/ulm_inside_outside/Show.vue"),
}